<template>
  <div class="sheet-list">
    <div class="sheet-header">
      <el-collapse
        v-model="$store.state.DiaActiveNames"
        accordion
        style="background-color: #f7fbf7"
      >
        <el-collapse-item :name="iType">
          <template slot="title">
            <img
              v-show="ikey === iType && $store.state.DiaActiveNames != iType"
              class="aside_div_icon"
              src="../../static/talks/icon_fullscreen2.png"
              alt="加载失败"
              style="padding-left: 4px"
            />
            <img
              v-show="ikey === iType && $store.state.DiaActiveNames == iType"
              class="aside_div_icon"
              src="../../static/talks/icon_fullscreen4.png"
              alt="加载失败"
              style="padding-left: 4px"
            />
            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '1'"
            >
              对话中（{{
                $store.state.currentColleageInfo === null
                  ? $store.getters.getTalkingList.length
                  : $store.getters.csgetTalkingList.length
              }}）
            </div>

            <!-- <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '2'"
            >
              浏览中（{{
                $store.state.currentColleageInfo === null
                  ? $store.getters.getBrowserList.length
                  : $store.getters.csgetBrowserList.length
              }}）
            </div> -->
            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '3'"
            >
              对话过（{{
                $store.state.currentColleageInfo === null
                  ? $store.getters.getTalkedList.length
                  : $store.getters.csgetTalkedList.length
              }}）
            </div>
            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '4'"
            >
              已离开（{{
                $store.state.currentColleageInfo === null
                  ? $store.getters.getLeavedList.length
                  : $store.getters.csgetLeavedList.length
              }}）
            </div>
            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '6'"
            >
              疑似骚扰用户（{{ $store.getters.getTroubleList.length }}）
            </div>
            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '7'"
            >
              在线访客列表（{{ $store.getters.getOnlineList.length }}）
            </div>

            <div
              :class="{ title_text: !showSheets, titled_text: showSheets }"
              v-if="iType == '8'"
            >
             已离开（未结束）（{{ $store.getters.getOnlineOffList.length }}）
            </div>
          </template>
          <div
            :class="[
              !$store.state.colleageAngle
                ? 'common-list'
                : 'common-list common-list2',
            ]"
            ref="scrollBar"
          >
            <div class="sheet-content" v-for="(i, k) in itemList" :key="k">
              <client-item
                :item="i"
                @selectClient="clientObj"
                :path="k"
                :type="iType"
              ></client-item>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import clientItem from "./clientItem.vue";
// import collegeList from './collegeList.vue'

export default {
  name: "clientCollapse",
  props: {
    itemList: {
      type: Array,
    },
    iType: {
      //1-会话中 2-浏览中 3-已离开 5-疑似骚扰用户
    },
  },
  components: {
    clientItem,
    // collegeList
  },
  computed: {
    colleageAngle() {
      return this.$store.state.colleageAngle;
    },
  },
  data() {
    return {
      showSheets: false,
      data_item: {},
      ikey: this.iType,
      isfold: true,
      loading: false,
      noMore: false,
    };
  },

  watch: {
  },
  created() {
    this.data_item = this.item;
  },
  mounted() {
    window.addEventListener("storage", (e) => {
      if (e.key === "colleagueNum") {
        this.$store.commit("changeColleagueNum", e.newValue);
      }
    });
  },
  methods: {
    // changeMydiaState(val) {
    //   if (val.indexOf(this.ikey) !== -1) {
    //     this.isfold = false;
    //   } else {
    //     this.isfold = true;
    //   }
    // },
    // changeScrollTop() {
    //   var el = this.$refs.infiniteListRef;
    //   el.scrollTo(0, 0);
    //   console.log("滚动元素：", el);
    // },

    clientObj(item, index) {
      console.log("===============", item, index);
      console.log("this.key:", this.ikey);
      this.$store.state.selectedKey = this.ikey;
      this.$store.state.selectedPath = index;
      this.$store.commit("setKeyNameFn", this.ikey);
      this.$emit("toList", item);
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.col_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #7a88ff;
}

.titleBg_div {
  width: 100%;
  height: 2.5rem;
  background: cyan;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.icon_img {
  width: 1rem;
  height: 1.125rem;
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.title_div {
  width: 90%;
  height: 100%;
  display: flex;
  align-items: center;
  /* background: chartreuse; */
}

.title_text,
.titled_text {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
}

.titled_text {
  color: #5a9cf8;
}

/* .arrow_div {
		width: 10%;
		background: #35B9FF;
		display: flex;
		justify-content: center;
		align-items: center;
	} */

.sheet-list {
  clear: both;
  background-color: #f7fbf7;
}
.common-list::-webkit-scrollbar {
  width: 6px;
  background-color: #f1f1f1;
  // display: none;
}
.common-list {
  &:hover {
    &::-webkit-scrollbar {
      width: 6px;
      background-color: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #bec5ca;
      border-radius: 10px;
    }
  }
}

.common-list {
  overflow: hidden auto;
  max-height: calc(100vh - 5 * 52px - 41px);
}
.common-list2 {
  max-height: calc(100vh - 3 * 52px - 41px);
}

// .scrollBar {
//   position: absolute;
//   top: 0;
//   right: 0;
//   width: 100%;
//   max-height: calc(100vh - 6 * 52px - 28px);
//   background-color: red;
// }

.sheet-header {
  width: 100%;
  // height: 45px;
  // background: #FFFFFF;
  background-color: #f1f1f1;
  position: relative;
  display: flex;
  margin-top: 2px;
  .el-collapse :deep() {
    width: 100%;
    .el-collapse-item__header {
      background-color: #f1f1f1;
    }
    .el-collapse-item__content {
      position: relative;
      max-height: none !important;
      padding-bottom: 0;
    }
    .el-collapse-item__arrow {
      display: none;
    }
  }
}
/* .arrow_div img:nth-child(1){
	line-height: 30px;position:absolute;
	right:10px;
	color:#666;
	transition:all 10s;
	background-color: #0000FF;
	} */
.arrow_div {
  width: 10%;
  /* height: 40px;position:absolute;
	right:10px; */
  color: #666;
  transition: all 0.8s;
  /* background: #35B9FF; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.sheet-header-i {
  line-height: 30px;
  position: absolute;
  right: 10px;
}
.sheet-header-span {
  left: 40px;
  font-size: 14px;
  position: absolute;
  line-height: 30px;
}
.sheet-content {
  position: relative;
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.sheet-content i {
  font-size: 26px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
}
.sheet-content-image {
  width: 60px;
  float: left;
  text-align: center;
  vertical-align: middle;
}
.sheet-content-middle {
  position: relative;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-left: 10px;
}
.sheet-content-middle p {
  font-size: 16px;
  width: 70%;
  color: #666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.aside_div_icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 4px;
}
.infinite-list {
  overflow: hidden auto;
}
.infinite-list::-webkit-scrollbar {
  display: none;
}

.twinkling {
  -webkit-animation: twinkling 1s infinite ease-in-out;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes twinkling {
  0% {
    // opacity: 0.0;
    background-color: #ffffad;
  }

  100% {
    // opacity: 0.6;
    background-color: #ffff00;
  }
}

@keyframes twinkling {
  0% {
    // opacity: 0.5;
    background-color: #ffffad;
  }

  100% {
    // opacity: 0.8;
    background-color: #ffff00;
  }
}
</style>
